<div #newMessageComponentReact></div>